<!-- ----------------------------------------------- -->
<template>
  <v-card id="rd-dialog" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header">
      <span class="com-mb-dialog-title">{{ text.title }}</span>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isReduction"
        v-show="!isSmall"
        small
        icon
        color="white"
        @click="reductionWindow"
      >
        <v-icon>minimize</v-icon>
      </v-btn>
      <v-btn v-show="isSmall" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col id="rd-contents" class="com-mb-dialog-contents">
      <v-col class="com-mb-dialog-frame" :class="isSmall ? 'py-0' : ''">
        <rd-movie v-if="!isReduction" :isSmall="isSmall"></rd-movie>
        <rd-opacity v-show="!isSmall"></rd-opacity>
        <rd-sns
          v-if="!isReduction"
          v-show="!isSmall"
          @reductionWindow="reductionWindow"
          @showOverlay="showOverlay"
          @expansionWindow="expansionWindow"
          @hideOverlay="hideOverlay"
          :isSmall="isSmall"
        ></rd-sns>
        <div v-if="dispOverlay" class="com-modal com-modal-overlay" data-html2canvas-ignore="true">
          <v-overlay>
            <v-progress-circular
              indeterminate
              :size="40"
              :width="6"
            ></v-progress-circular>
          </v-overlay>
        </div>
        <rd-type v-show="!isSmall"></rd-type>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]レーダ雨量ダイアログ
 * Radar.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import util from "./../../../lib/util.js";
import RdType from "./../../../components/mb/RdType";
import RdSns from "./../../../components/mb/RdSns";
import RdMovie from "./../../../components/mb/RdMovie";
import RdOpacity from "./../../../components/mb/RdOpacity";

export default {
  /** タグ名 */
  name: "mb-radar",
  mixins: [mixin],
  components: {
    RdType,
    RdSns,
    RdMovie,
    RdOpacity,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "レーダ雨量",
        hint:
          "XRAINの観測範囲から外れている場合はCバンドレーダを利用してください",
      },
      isSmall: false,
      dispOverlay: false,
    };
  },
  created() {
    this.$log.debug("[radar] created()");
    const urlTime = this.$route.query["rdtime"];
    const urlType = this.$route.query["rdtype"];
    const urlOpa = this.$route.query["rdopa"];
    if (urlTime != undefined) {
      // 日付形式をチェック
      let setTime = new Date();
      if (util.formatDate(urlTime) !== "Invalid Date") {
        setTime = util.toDate(urlTime);
      }
      this.$store.commit("app/setTime", setTime);
    }
    if (urlType != undefined) {
      this.$store.commit(
        "radar/setType",
        urlType == "xrain" ? "xrain" : "cband"
      );
    }
    if (urlOpa != undefined) {
      this.$store.commit("radar/setOpacity", (Number(urlOpa) / 10) * 10);
    }
    this.$store.commit(
      "radar/setHistoryPlayTime",
      this.$store.state.app.appTime
    );
    this.replaceRadarQueryForMb();
  },
  mounted() {
    this.$log.debug("[radar] mounted()");

    this.$store.commit("radar/setNumber", 1);
    this.$store.commit("radar/resetHistoryPlay");
    this.$store.commit("app/setContent", "Radar");
  },
  computed: {
    /** 地域名 */
    areaName: {
      get() {
        let map = this.$store.state.map;
        return map.prefName + map.townName;
      },
    },
    /** 簡易版判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
  },
  /** メソッド */
  methods: {
    /** 画面を小さくする */
    reductionWindow() {
      this.$log.debug("[radar] reductionWindow()");
      var dlg = document.getElementById("rd-dialog");
      dlg.className = "com-mb-dialog small v-card v-sheet theme--light";

      this.isSmall = true;
    },
    /** 画面を戻す */
    expansionWindow() {
      this.$log.debug("[radar] expansionWindow()");
      var dlg = document.getElementById("rd-dialog");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";

      this.isSmall = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$log.debug("[radar] closeDlg()");
      this.$store.commit("radar/resetHistoryPlay");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    showOverlay() {
      this.dispOverlay = true;
    },
    hideOverlay() {
      this.dispOverlay = false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .small {
    width: 50%;
    max-width: 400px;
    height: 110px;
    bottom: 4px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .small {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 110px;
    bottom: 4px;
  }
}

#rd-dialog {
  right: 4px;
}
</style>
